import moment from 'moment-timezone'

import { getAPIURL } from './GlobalComponents/URLs'
import { VendorProductCode } from './@types/InventoryDS'

export const formatContact = (row: ContactCustomerAccountCodeViewRow) => {
    return (
        `${row.FirstName.trim()} ${row.LastName.trim()} ` +
        (row.EmailAddress ? `<${row.EmailAddress}>` : '')
    )
}

export const formatVPC = (row: VendorProductCode) => {
    return `${row.VendorID.trim()}/${row.ProductCode.trim()}${
        row.Name ? ` - ${row.Name.trim()}` : ''
    }`
}

export const trimSemicolons = (raw: string) => {
    return /^;*(.*?);*$/.exec(raw)![1]
}

export const toLowerEquals = (s1: string, s2: string) => {
    return s1.toLowerCase() === s2.toLowerCase()
}

export const getNumDecimalPlaces = (num: number) => {
    let matches = /^\d*(?:\.(\d+0?)?$)/.exec(num.toString())
    return matches && matches[1] ? matches[1].length : 0
}

export const formatMoney = (num: number | undefined) => {
    if (num === undefined) return ''
    let showDecimals = Math.max(2, getNumDecimalPlaces(num))
    showDecimals = Math.min(showDecimals, 4)
    return num.toFixed(showDecimals)
}

export const formatPhoneNumber = (phone: string, phoneExtension: string) => {
    let phoneNumber = phone
    let tempPhone = ''
    // If US Phone number
    if (phoneNumber.length === 11 && phoneNumber[0] === '1') {
        tempPhone =
            '(' +
            phoneNumber.substring(1, 4) +
            ') ' +
            phoneNumber.substring(4, 7) +
            '-' +
            phoneNumber.substring(7, 11)
    } // Otherwise we just add a + in front
    else tempPhone = '+' + phoneNumber

    // Add extension if exists
    if (phoneExtension !== '') {
        tempPhone += ' x' + phoneExtension
    }

    return tempPhone.trim() === '+' ? '' : tempPhone
}

export interface User {
    CompanyCode: string
    Username: string
    Firstname: string
    Lastname: string
    Email: string
    TelephoneNumber: string
    Warehouse: string
    Position: string
}
// interface User {
//     User: {
//         CompanyCode: string
//         Username: string
//         CompanyName: string
//         Firstname: string
//         Lastname: string
//         Email: string
//         Warehouse: string
//         WarehouseName: string
//         EmployeeNo: string
//         TelephoneNumber: string
//         Extension: string
//         FaxNumber: string
//         ID: number
//         EmailSurveyCC: string
//         PublishCellPhone: boolean
//         PublishHomePhone: boolean
//         isLinkedToPayroll: boolean
//         HomeWarehouse: string
//         EmailQuoteFollowUp: boolean
//         IsInactive: boolean
//         HRCompanyCode: string
//         CellPhoneCarrierID: number
//         SMSAlerts: boolean
//         CellPhoneCarrierName: string
//         RowError?: string
//         RowState?: number
//         Table?: Array<User>
//         ItemArray?: Array<any>
//         HasErrors?: boolean
//     }
// }

let user: ReturnType<typeof fetchGetCurrentUser> | null = null
export const getCurrentUser = async () => {
    if (user) return await user
    user = fetchGetCurrentUser()
    return await user
}
// export const cancelSearch = () => initController.abort()
export const fetchGetCurrentUser = async (): Promise<User> => {
    let url = getAPIURL() + 'user/CurrentUser'
    let req = await fetch(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    })
    return await req.json()
}

export const convertToCentralTime = (d: Date) => {
    return moment(d).tz('US/Central', false).toDate()
}

export const getTimeDiff = (d1: Date, d2: Date) => {
    let d1Moment = moment(d1).utc()
    let d2Moment = moment(d2).utc()
    return d2Moment.diff(d1Moment) // difference in milliseconds
}
